import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import type {
  CreatePromotionRequest,
  PromotionDto,
  UpdatePromotionRequest,
} from './types';

const QK = ['promotions'] as const;

export function usePromotions() {
  return useQuery({
    queryKey: QK,
    queryFn: async () =>
      (await apiClient.get<PromotionDto[]>('/api/promotions')).data,
  });
}

export function useCreatePromotion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (request: CreatePromotionRequest) =>
      (await apiClient.post<PromotionDto>('/api/promotions', request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useUpdatePromotion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, request }: { id: string; request: UpdatePromotionRequest }) =>
      (await apiClient.put<PromotionDto>(`/api/promotions/${id}`, request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useDeletePromotion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(`/api/promotions/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
